<template>
    <div class="grid-videos" v-if="lstVideos">
        <div class="row px-3" v-if="lstVideos.length > 0">

            <!-- template 5 videos -->
            <template v-if="lstVideos.length == 5">
                <div class="col-12 col-lg-6 px-0 mb-3">
                    <router-link :to="{name:'Video', params:{id:lstVideos[0].id.toString(),n:formatLink(lstVideos[0].titulo)}}">
                        <div class="box-video">
                            <img class="w-100 img-video" :src="lstVideos[0].img" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                            <div class="detalhes-video">
                                <span class="badge badge-primary text-uppercase">{{lstVideos[0].categoria}}</span>
                                <p class="txt-cores-1 reduz-texto-2 mb-0">{{lstVideos[0].titulo}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-12 col-lg-6 px-0">
                    <div class="d-flex w-100 flex-wrap">

                        <div class="col-12 col-lg-6 pl-0 pl-lg-3 pr-0 mb-3" v-for="item in lstVideos.slice(1)" :key="item.id">
                            <router-link :to="{name:'Video', params:{id:item.id.toString(),n:formatLink(item.titulo)}}">
                                <div class="box-video box-video-p">
                                    <img class="w-100 img-video" :src="item.img" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                    <div class="detalhes-video">
                                        <span class="badge badge-primary text-uppercase">{{item.categoria}}</span>
                                        <p class="txt-cores-1 reduz-texto-2 mb-0">{{item.titulo}}</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>


                    </div>
                </div>
            </template>

            <!-- template 3 videos -->
            <template v-else>
                <div class="col-12 col-lg-8 px-0 mb-3">
                    <router-link :to="{name:'Video', params:{id:lstVideos[0].id.toString(),n:formatLink(lstVideos[0].titulo)}}">
                        <div class="box-video">
                            <img class="w-100 img-video" :src="lstVideos[0].img" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                            <div class="detalhes-video">
                                <span class="badge badge-primary text-uppercase">{{lstVideos[0].categoria}}</span>
                                <p class="txt-cores-1 reduz-texto-2 mb-0">{{lstVideos[0].titulo}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-12 col-lg-4 px-0">
                    <div class="d-flex w-100 flex-wrap">
                        <div class="col-12 col-lg-12 pl-0 pl-lg-3 pr-0 mb-3" v-for="item in lstVideos.slice(1)" :key="item.id">
                            <router-link :to="{name:'Video', params:{id:item.id.toString(),n:formatLink(item.titulo)}}">
                                <div class="box-video box-video-p">
                                    <img class="w-100 img-video" :src="item.img" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                    <div class="detalhes-video">
                                        <span class="badge badge-primary text-uppercase">{{item.categoria}}</span>
                                        <p class="txt-cores-1 reduz-texto-2 mb-0">{{item.titulo}}</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                
            </template>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'GridVideos',
        data() {
            return {
            }
        },
        props: {
            lstVideos: {
                type: Array,
                required: true
            }
        },
        methods: {
            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }
            },
        },
        mounted() {
        },
        
    }
</script>

<style lang="scss">
    /* GRID VIDEOS */
    .grid-videos {
        .box-video {
            position: relative;
            cursor: pointer;

            .img-video {
                border-radius: 3px;
            }

            .detalhes-video {
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 10px;
                z-index: 1;
                opacity: 1;
            }
        }

        .box-video:hover:after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0,0,0,0.3);
        }

        .box-video:before {
            position: absolute;
            content: "";
            display: block;
            transition: opacity .3s;
            width: 100%;
            height: 100%;
            background: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyNDAiPjxkZWZzPjxmaWx0ZXIgeD0iLTUwJSIgeT0iLTUwJSIgd2lkdGg9IjIwMCUiIGhlaWdodD0iMjAwJSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iYSI+PGZlT2Zmc2V0IGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyLjUiIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIvPjxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC41MjUgMCIgaW49InNoYWRvd0JsdXJPdXRlcjEiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIxIi8+PGZlTWVyZ2U+PGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiLz48ZmVNZXJnZU5vZGUgaW49IlNvdXJjZUdyYXBoaWMiLz48L2ZlTWVyZ2U+PC9maWx0ZXI+PC9kZWZzPjxwYXRoIGQ9Ik0yNC4zNSAxNy4wNDVMNi41OCA1LjE2N0M2LjQyMyA1LjA2MiA2LjI0IDUgNi4wNCA1IDUuNDY4IDUgNSA1LjUyIDUgNi4xNmwuMDAyLjA0OEg1VjI5LjljMCAuNjQuNDY3IDEuMTYgMS4wNCAxLjE2LjE5NyAwIC4zOC0uMDYyLjUzNS0uMTY2TDI0LjM1IDE5LjAxNmMuMjk1LS4yMDYuNDkzLS41Ny40OTMtLjk4NyAwLS40MTctLjE5Ny0uNzgtLjQ5My0uOTg1IiBvcGFjaXR5PSIuODUiIGZpbGw9IiNGRkYiIGZpbHRlcj0idXJsKCNhKSIvPjwvc3ZnPg==) no-repeat 50%;
            opacity: 1;
            z-index: 1;
            top: -5px;
            left: 0;
            background-size: 65px 79px;
        }

        .box-video-p:before {
            background-size: 30px 30px;
        }
    }

    @media (max-width: 575.98px) {
        .box-video-p:before {
            background-size: 65px 79px !important;            
        }
    }

    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) and (max-width: 999px) {
        .box-video-p:before {
            background-size: 65px 79px !important;
        }
    }

</style>